"use strict";
exports.__esModule = true;
exports.GdcExecuteAFM = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Types defined here exactly match types accepted by the executeAfm resource.
 *
 * Types currently map executeAfm version 3.
 *
 * @public
 */
var GdcExecuteAFM;
(function (GdcExecuteAFM) {
    function isObjectUriQualifier(qualifier) {
        return !isEmpty_1["default"](qualifier) && qualifier.uri !== undefined;
    }
    GdcExecuteAFM.isObjectUriQualifier = isObjectUriQualifier;
    function isObjIdentifierQualifier(qualifier) {
        return (!isEmpty_1["default"](qualifier) &&
            qualifier.identifier !== undefined);
    }
    GdcExecuteAFM.isObjIdentifierQualifier = isObjIdentifierQualifier;
    function isLocalIdentifierQualifier(qualifier) {
        return (!isEmpty_1["default"](qualifier) &&
            qualifier.localIdentifier !== undefined);
    }
    GdcExecuteAFM.isLocalIdentifierQualifier = isLocalIdentifierQualifier;
    function isSimpleMeasureDefinition(definition) {
        return (!isEmpty_1["default"](definition) &&
            definition.measure !== undefined);
    }
    GdcExecuteAFM.isSimpleMeasureDefinition = isSimpleMeasureDefinition;
    function isArithmeticMeasureDefinition(definition) {
        return (!isEmpty_1["default"](definition) &&
            definition.arithmeticMeasure !== undefined);
    }
    GdcExecuteAFM.isArithmeticMeasureDefinition = isArithmeticMeasureDefinition;
    function isPopMeasureDefinition(definition) {
        return (!isEmpty_1["default"](definition) &&
            definition.popMeasure !== undefined);
    }
    GdcExecuteAFM.isPopMeasureDefinition = isPopMeasureDefinition;
    function isPreviousPeriodMeasureDefinition(definition) {
        return (!isEmpty_1["default"](definition) &&
            definition.previousPeriodMeasure !== undefined);
    }
    GdcExecuteAFM.isPreviousPeriodMeasureDefinition = isPreviousPeriodMeasureDefinition;
    function isAttributeSortItem(sortItem) {
        return (!isEmpty_1["default"](sortItem) &&
            sortItem.attributeSortItem !== undefined);
    }
    GdcExecuteAFM.isAttributeSortItem = isAttributeSortItem;
    function isMeasureSortItem(sortItem) {
        return (!isEmpty_1["default"](sortItem) && sortItem.measureSortItem !== undefined);
    }
    GdcExecuteAFM.isMeasureSortItem = isMeasureSortItem;
    function isAttributeLocatorItem(locator) {
        return (!isEmpty_1["default"](locator) &&
            locator.attributeLocatorItem !== undefined);
    }
    GdcExecuteAFM.isAttributeLocatorItem = isAttributeLocatorItem;
    function isMeasureLocatorItem(locator) {
        return (!isEmpty_1["default"](locator) &&
            locator.measureLocatorItem !== undefined);
    }
    GdcExecuteAFM.isMeasureLocatorItem = isMeasureLocatorItem;
    function isDateFilter(filter) {
        return !isEmpty_1["default"](filter) && (isRelativeDateFilter(filter) || isAbsoluteDateFilter(filter));
    }
    GdcExecuteAFM.isDateFilter = isDateFilter;
    function isRelativeDateFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.relativeDateFilter !== undefined;
    }
    GdcExecuteAFM.isRelativeDateFilter = isRelativeDateFilter;
    function isAbsoluteDateFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.absoluteDateFilter !== undefined;
    }
    GdcExecuteAFM.isAbsoluteDateFilter = isAbsoluteDateFilter;
    function isAttributeFilter(filter) {
        return !isEmpty_1["default"](filter) && (isPositiveAttributeFilter(filter) || isNegativeAttributeFilter(filter));
    }
    GdcExecuteAFM.isAttributeFilter = isAttributeFilter;
    function isPositiveAttributeFilter(filter) {
        return (!isEmpty_1["default"](filter) &&
            filter.positiveAttributeFilter !== undefined);
    }
    GdcExecuteAFM.isPositiveAttributeFilter = isPositiveAttributeFilter;
    function isNegativeAttributeFilter(filter) {
        return (!isEmpty_1["default"](filter) &&
            filter.negativeAttributeFilter !== undefined);
    }
    GdcExecuteAFM.isNegativeAttributeFilter = isNegativeAttributeFilter;
    function isMeasureValueFilter(filter) {
        return (!isEmpty_1["default"](filter) && filter.measureValueFilter !== undefined);
    }
    GdcExecuteAFM.isMeasureValueFilter = isMeasureValueFilter;
    function isRankingFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.rankingFilter !== undefined;
    }
    GdcExecuteAFM.isRankingFilter = isRankingFilter;
    function isExpressionFilter(filter) {
        return !isEmpty_1["default"](filter) && filter.expression !== undefined;
    }
    GdcExecuteAFM.isExpressionFilter = isExpressionFilter;
    function isAttributeElementsArray(attributeElements) {
        return attributeElements !== undefined && attributeElements instanceof Array;
    }
    GdcExecuteAFM.isAttributeElementsArray = isAttributeElementsArray;
    function isAttributeElementsByRef(attributeElements) {
        return (!isEmpty_1["default"](attributeElements) &&
            attributeElements.uris !== undefined);
    }
    GdcExecuteAFM.isAttributeElementsByRef = isAttributeElementsByRef;
    function isAttributeElementsByValue(attributeElements) {
        return (!isEmpty_1["default"](attributeElements) &&
            !isArray_1["default"](attributeElements) &&
            attributeElements.values !== undefined);
    }
    GdcExecuteAFM.isAttributeElementsByValue = isAttributeElementsByValue;
})(GdcExecuteAFM = exports.GdcExecuteAFM || (exports.GdcExecuteAFM = {}));
//# sourceMappingURL=GdcExecuteAFM.js.map